function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-ios-expand",
  "data-name": "Icon ionic-ios-expand",
  transform: "translate(-4.5 -4.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M6.657,5.748H9.486a.618.618,0,0,0,.62-.62V5.12a.618.618,0,0,0-.62-.62H5.12a.618.618,0,0,0-.62.619V9.486a.618.618,0,0,0,.62.62h.009a.618.618,0,0,0,.62-.62V6.657L9.967,10.84a.613.613,0,0,0,.437.178.6.6,0,0,0,.437-.183.619.619,0,0,0,0-.874Z",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M26.536,4.5H22.169a.618.618,0,0,0-.619.62v.009a.618.618,0,0,0,.619.62H25L20.815,9.967a.619.619,0,0,0,.874.878l4.219-4.188V9.486a.618.618,0,0,0,.62.62h.009a.618.618,0,0,0,.62-.62V5.12A.618.618,0,0,0,26.536,4.5Z",
  transform: "translate(-5.541)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M10.4,20.631a.613.613,0,0,0-.437.178L5.748,25V22.168a.618.618,0,0,0-.62-.62H5.12a.618.618,0,0,0-.62.62v4.367a.618.618,0,0,0,.62.62H9.486a.618.618,0,0,0,.62-.62v-.009a.618.618,0,0,0-.62-.62H6.657l4.183-4.219a.62.62,0,0,0-.437-1.056Z",
  transform: "translate(0 -5.54)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M26.536,21.551h-.009a.618.618,0,0,0-.62.62V25l-4.219-4.183a.613.613,0,0,0-.437-.178.6.6,0,0,0-.437.183.619.619,0,0,0,0,.874L25,25.909H22.169a.618.618,0,0,0-.62.62v.009a.618.618,0,0,0,.62.619h4.367a.618.618,0,0,0,.62-.619V22.171A.618.618,0,0,0,26.536,21.551Z",
  transform: "translate(-5.541 -5.543)",
  fill: "#fff"
}));

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.114,
    height: 17.114,
    viewBox: "0 0 17.114 17.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.7cf2b99f.svg";
export { ForwardRef as ReactComponent };